import { graphql } from "@opensea/graphql"
import { getMediaPropsFromMediaFragment } from "../utils"

export const HeroMediaFragment = graphql(
  `
    fragment CollectionOverviewHeroMedia on Collection {
      hero {
        desktopHeroMedia {
          ...MediaProps
        }
        mobileHeroMedia {
          ...MediaProps
        }
      }
    }
  `,
  [getMediaPropsFromMediaFragment],
)
